import { createSlice } from "@reduxjs/toolkit";

const initialMerchantItemState = {
    listLoading: false,
    actionsLoading: false,
    totalCount: 0,
    entities: [],
    merchantitemForEdit: undefined,
    lastError: null,
    message: null,
    error: null,
};
export const callTypes = {
    list: "list",
    action: "action"
};

export const merchantitemSlice = createSlice({
    name: "merchantitems",
    initialState: initialMerchantItemState,
    reducers: {
        catchError: (state, action) => {
            state.error = action.payload.error.clientMessage;
            if (action.payload.callType === callTypes.list) {
                state.listLoading = false;
            } else {
                state.actionsLoading = false;
            }
        },
        startCall: (state, action) => {
            state.error = null;
            state.message = null;

            if (action.payload.callType === callTypes.list) {
                state.listLoading = true;
            } else {
                state.actionsLoading = true;
            }
        },
        endCall: (state, action) => {
            state.error = null;
            state.message = null;
            if (action.payload.callType === callTypes.list) {
                state.listLoading = false;
            } else {
                state.actionsLoading = false;
            }
        },
        // getMerchantItemById
        merchantitemFetched: (state, action) => {
            state.actionsLoading = false;
            state.merchantitemForEdit = action.payload.merchantitemForEdit;
            state.floorPlans = action.payload.merchantitemForEdit.floorPlans;
            state.error = null;

        },
        // getMerchantItemChart
        merchantitemChartFetched: (state, action) => {

            state.actionsLoading = false;
            state.merchantitemChart = action.payload.merchantitemChart;
            state.error = null;

        },
        // getMerchantItemChart
        merchantitemHourlyChartFetched: (state, action) => {
            state.actionsLoading = false;
            state.merchantitemChartHour = action.payload.merchantitemChartHour;
            state.error = null;

        },
        // getMerchantItemChart
        merchantitemHourlyZoneChartFetched: (state, action) => {
            state.actionsLoading = false;
            state.merchantitemChartHourZone = action.payload.merchantitemChartHourZone;
            state.error = null;

        },
        // get list data
        merchantitemsFetched: (state, action) => {
            const { totalCount, entities } = action.payload;
            state.listLoading = false;
            state.error = null;
            state.entities = entities;
            state.totalCount = totalCount;
            state.merchantitemForEdit = undefined;
            state.floorPlans = undefined;
            state.merchantitemChart = undefined;
            state.merchantitemChartHour = undefined;
            state.merchantitemChartHourZone = undefined;
        },
        // createMerchantItem
        merchantitemCreated: (state, action) => {
            state.actionsLoading = false;
            state.error = null;
            state.message = action.payload.msgResponse;
        },
        // updateMerchantItem
        merchantitemUpdated: (state, action) => {
            state.error = null;
            state.actionsLoading = false;
            state.message = action.payload.msgResponse;
        },
        // merchantitemDeleted
        merchantitemDeleted: (state, action) => {
            state.error = null;
            state.message = action.payload.msgResponse;
            state.actionsLoading = false;
        },
        setMessage: (state, action) => {
            state.error = null;
            state.message = action.payload.msgResponse;
        },
        floorPlanDeleted: (state, action) => {
            state.error = null;
            state.actionsLoading = false;
            state.floorPlans = state.floorPlans.filter(item => item.id !== action.payload.id);
        },
        floorPlanUpdated: (state, action) => {
            const { id, floorPlan } = action.payload;
            state.error = null;
            state.actionsLoading = false;
            state.floorPlans = state.floorPlans.map((data) => {

                if (data.id === id) {
                    return floorPlan;
                }

                return data;
            });
        }

    }
});
